module.exports = __webpack_public_path__ + "static/img/3x3.426ad7d5.svg";